import {getTimezoneAbbreviation} from 'nutshell-core/date-time';
import {formatTimestampForTimeline} from 'nutshell-core/date-time/formatting';

import type {Webcast as WebcastFragment} from 'nutshell-graphql-types';

export function getTimestampForWebcast(webcast: WebcastFragment) {
    const timezoneAbbreviation = getTimezoneAbbreviation(webcast.timestamp);

    return `${formatTimestampForTimeline(webcast.timestamp)} ${timezoneAbbreviation || ''}`;
}
